export default function (mortgage, config) {
    let map = {}
    let ask = []
    map['name 1'] = {string: mortgage.applicant1.fullName}
    if (mortgage.twoApplicants){
        map['name 2'] = {string: mortgage.applicant2.fullName}
    }
    map['number'] = {string: mortgage.activeSubmission?.mortgageAccountNo}
    map['address'] = {string: mortgage.property.address}
    return {sections:[{map, ask}]}
}